"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Sat Oct 13 2018
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * CRPDTOConverter
 *
 * @author RV
 */


var CRPDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CRPDTOConverter, _DataObjectConverter_);

  function CRPDTOConverter() {
    _classCallCheck(this, CRPDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CRPDTOConverter).apply(this, arguments));
  }

  return CRPDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CRPDTOConverter = CRPDTOConverter;